import React from 'react';
import {TableBody} from "@material-ui/core";
import TableRowList from "./TableRowList";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import ListHoc from "../../../../../HocHelpers/ListHoc";
import _ from 'lodash';
import Button from "@material-ui/core/Button";

const TableBodyList = props => {
    const {
        data,
        listRecord,
        selectedRows,
        page,
        paged,
        rowsPerPage,
        columns,
        pivotData = [],
        pivotColumns = [],
        loadSampleData,
        loadedSampleData
    } = props;
    let currentConnector = listRecord?.source?.inPlaceConnection?.connector;
    let newData = (pivotColumns.length && pivotData.length) ? pivotData : data.content;
    let rows = [];
    if (newData?.length > 0) {
        rows = setValues(!paged, page, rowsPerPage, newData);
    }

    const renderRows = (rows = [], selectedRows) => {
        return (
            <>
                {rows.slice(0, 25).map((row, index) => {
                    let isSelected = _.findIndex(selectedRows, row) !== -1;
                    return (
                        <TableRowList
                            key={index}
                            index={index}
                            row={row}
                            isSelected={isSelected}
                        />
                    )
                })}
            </>

        )
    };
    const NoDataRow = () => {
        let cols = 0;
        if (columns) cols = columns.length + 1

        return (
            <TableRow>
                <TableCell colSpan={cols} style={{textAlign: "center"}}>
                    {currentConnector === 'sbEntity' ?
                        loadedSampleData ? 'No Data' : 'Data is not loaded' :
                        "No data"}
                    {currentConnector === 'sbEntity' && (
                        <div>
                            <Button
                                onClick={loadSampleData}
                                variant={'outlined'} size={'small'} color={'primary'}
                                style={{
                                    marginTop: 10
                                }}
                            >
                                Load sample data
                            </Button>
                        </div>
                    )}
                </TableCell>
            </TableRow>
        )
    };
    if (paged) {
        return (
            <TableBody>
                {(newData?.length > 0 ? renderRows(newData, selectedRows) : <NoDataRow/>)}
            </TableBody>
        )
    }

    return (
        <>
            <TableBody>
                {(rows.length > 0 ? renderRows(newData, selectedRows) : <NoDataRow/>)}
            </TableBody>
        </>
    )
}

export default ListHoc(TableBodyList);

function setValues(paged, page, rowsPerPage = 20, data) {
    if (paged) {
        return data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    } else {
        return data
    }
}